import { Language } from 'types/language'

export type EncyclopediaProps = {
  articles: Article[]
  categories: Category[]
  content: EncyclopediaContent
}

export type CmsImage = {
  url: string
  width: number
  height: number
  alternativeText: string
}

export type EncyclopediaContent = {
  title: string
  description: string
  coverImage: CmsImage
  searchTitle: string
  searchPlaceholder: string
  popularTitle: string
  seo: SEO
}

export type EncyclopediaCatProps = {
  allArticles: Article[]
  categoryContent: Category
  relatedArticles: Article[]
  subCategories?: SubCategory[]
}

export type EncyclopediaSubCategoryProps = {
  articles: Article[]
  subCategory: SubCategory
}

export type EncyclopediaArticleProps = {
  allArticles: Article[]
  articleContent: Article
}

export type Article = {
  id: number
  author: Author
  contentBlocks: ContentBlock[]
  category: Category
  description: string
  isHighlighted?: boolean
  isHighlightedLanding?: boolean
  isPopular?: boolean
  locale: Language
  publishedAt: Date | string
  updatedAt: Date | string
  seo?: SEO
  slug: string
  subCategory: SubCategory
  thumbnail: string
  title: string
}

export type SEO = {
  seoTitle: string
  metaDescription: string
}

export type ContentBlock = {
  id: number
  author?: string
  type?: ContentBlocks
  body?: string
  image?: any
  quote?: string
  information?: string
}

export type Author = {
  id: number
  avatar?: string
  firstName: string
  lastName?: string
  personalizedFooter?: {
    title: string
    description: string
  }
}

export type Category = {
  id: number
  hoverAnimation?: string
  color: string
  description?: string
  icon?: string
  locale: Language
  publishedAt?: Date
  seo: SEO
  slug: string
  title: string
}

export type SubCategory = {
  id: number
  category?: Category
  description?: string
  locale: Language
  seo: SEO
  slug: string
  title: string
}

export type HeroProps = {
  category: Category
  subCategory?: string
}

// ENUMS

export enum ContentBlocks {
  RICH_TEXT = 'content-blocks.rich-text',
  IMAGE = 'content-blocks.image',
  QUOTE = 'content-blocks.quote',
  GOOD_TO_KNOW = 'content-blocks.good-to-know'
}

export enum Animations {
  HOUSE = 'house',
  BROCCOLI = 'broccoli',
  SOLAR_PANEL = 'solarPanel'
}
